<template>
	<div class="navs">
		<transition name="fade">
			<nav class="main-nav" v-if="this.$route.path !== '/order'">
				<ul>
					<li><router-link to="/" tag="a">Home</router-link></li>
					<li><router-link to="/order" tag="a">Menu/Order</router-link></li>
					<li><button @click="handleOpenHours" class="hours-button">Hours</button></li>
					<li><router-link to="/" tag="a" hash="#contact">Contact</router-link></li>
					<li><router-link to="/" tag="a" href="#contact">Catering</router-link></li>
					<li><router-link to="/gallery" tag="a">Photo Gallery</router-link></li>
					<li><router-link to="/reviews" tag="a">Reviews</router-link></li>
				</ul>
			</nav>
		</transition>
		<div class="order-nav" @click="openNav" v-if="this.$route.path === '/order'">
			<div class="hamburger">
				<div>
					<span></span>
				</div>
			</div>
		</div>
		<div class="hamburger-nav" @click="openNav">
			<div class="hamburger">
				<div>
					<span></span>
				</div>
			</div>
		</div>
		<transition name="fade">
			<nav class="mobile-nav" v-if="navOpen" @click="openNav">
				<div class="wrapper">
					<ul>
						<li><router-link to="/" tag="a">Home</router-link></li>
						<li><router-link to="/order" tag="a">Menu/Order</router-link></li>
						<li><router-link hash="contact">Contact</router-link></li>
						<li><router-link tag="a" href="#gallery">Photo Gallery</router-link></li>
						<li><router-link to="/reviews" tag="a">Reviews</router-link></li>
						<li><a href="#catering">Catering</a></li>
					</ul>
				</div>
			</nav>
		</transition>
	</div>
</template>

<script>
	import $ from 'jquery'

	export default {
		name: 'MyNav',
		data () {
			return {
				navOpen: false
			}
		},
		methods: {
			openNav () {
				$('.hamburger').toggleClass('open')
				this.navOpen = !this.navOpen
			},
			handleOpenHours () {
				this.$emit('openHours')
			}
		}
	}
</script>

<style lang='scss' scoped>
	@import '../assets/css/main';

	.navs {
		margin-bottom: 5%;
		.main-nav {
			border-bottom: 1px solid $primary-color;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/MyNav.vue